module.exports = __webpack_public_path__ + "static/media/v3logoGreen.9f679c12.svg";